// import React, { useState, useEffect, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import Search from './Search';
// import { fetchBusinessById, API_URL } from '../services/api';
// import axios from 'axios';
// import { Helmet } from 'react-helmet';

// // Cache constants
// const CACHE_KEY = 'shop_products_cache';
// const CACHE_EXPIRY = 20 * 60 * 1000; // 20 minutes in milliseconds
// const FILTER_CACHE_KEY = 'shop_filters_cache';

// const Shop = () => {
//   const [products, setProducts] = useState([]);
//   const [businessNames, setBusinessNames] = useState({});
//   const [loading, setIsLoading] = useState(true);
//   const [cacheLoaded, setCacheLoaded] = useState(false);
//   const [hasMatchingCache, setHasMatchingCache] = useState(false);

//   // Pagination state
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalProducts, setTotalProducts] = useState(0);
//   const [nextPageUrl, setNextPageUrl] = useState(null);
//   const [prevPageUrl, setPrevPageUrl] = useState(null);
//   const productsPerPage = 20;
//   const productsfordeadends = [414, 2802, 1713, 1721, 1748, 1819, 2440]; // CHANGE THIS FOR THE ACTUAL PRODUCTS
//   const [deadEndProducts, setDeadEndProducts] = useState([]);
//   const [loadingDeadEnds, setLoadingDeadEnds] = useState(false);

//   // Search API ref for the child component to use
//   const searchRef = React.useRef();

//   // Ref to prevent duplicate cache saves
//   const cacheUpdateTimerRef = useRef(null);
//   const cacheSavedDataRef = useRef(null);

//   // Optimized cache helpers
//   const saveToCache = (cacheData) => {
//     const stringifiedData = JSON.stringify(cacheData);

//     if (cacheSavedDataRef.current === stringifiedData) {
//       return;
//     }

//     cacheSavedDataRef.current = stringifiedData;

//     if (cacheUpdateTimerRef.current) {
//       clearTimeout(cacheUpdateTimerRef.current);
//     }

//     cacheUpdateTimerRef.current = setTimeout(() => {
//       try {
//         localStorage.setItem(CACHE_KEY, stringifiedData);
//       } catch (error) {
//         console.error('Error saving to cache:', error);
//       }
//       cacheUpdateTimerRef.current = null;
//     }, 300); // Reduced debounce for faster caching
//   };

//   const getFromCache = () => {
//     try {
//       const cachedItem = localStorage.getItem(CACHE_KEY);
//       if (!cachedItem) return null;

//       const parsedCache = JSON.parse(cachedItem);
//       const { data, timestamp } = parsedCache;

//       if (Date.now() - timestamp > CACHE_EXPIRY) {
//         localStorage.removeItem(CACHE_KEY);
//         return null;
//       }

//       cacheSavedDataRef.current = cachedItem;
//       return data;
//     } catch (error) {
//       console.error('Error reading from cache:', error);
//       localStorage.removeItem(CACHE_KEY);
//       return null;
//     }
//   };

//   const getCachedFilters = () => {
//     try {
//       const cachedFilters = localStorage.getItem(FILTER_CACHE_KEY);
//       if (cachedFilters) {
//         return JSON.parse(cachedFilters);
//       }
//     } catch (error) {
//       console.error('Error reading cached filters:', error);
//     }
//     return null;
//   };

//   // Check if cached data matches current filters
//   const doesCacheMatchFilters = (cachedData, filters) => {
//     if (!cachedData || !cachedData.appliedFilters) return false;

//     const { searchTerm, selectedFilter, selectedCategory } = filters;
//     const cached = cachedData.appliedFilters;

//     return cached.searchTerm === searchTerm &&
//            cached.selectedFilter === selectedFilter &&
//            cached.selectedCategory === selectedCategory;
//   };

//   // Load data once on component mount
//   // useEffect(() => {
//   //   const loadData = async () => {
//   //     // First check cache
//   //     const cachedData = getFromCache();
//   //     const cachedFilters = getCachedFilters();

//   //     if (cachedData && cachedFilters && doesCacheMatchFilters(cachedData, cachedFilters)) {
//   //       console.log('Loading products from cache with matching filters');
//   //       // Set the cached data
//   //       setProducts(cachedData.products || []);
//   //       setBusinessNames(cachedData.businessNames || {});
//   //       setTotalProducts(cachedData.totalProducts || 0);
//   //       setNextPageUrl(cachedData.nextPageUrl);
//   //       setPrevPageUrl(cachedData.prevPageUrl);
//   //       setCurrentPage(cachedData.currentPage || 1);
//   //       setHasMatchingCache(true);

//   //       // Show cached content immediately
//   //       setIsLoading(false);
//   //       setCacheLoaded(true);

//   //       // Fetch fresh data in background without showing loading spinner
//   //       fetchProductsData(cachedData.currentPage || 1, false);
//   //     } else if (cachedData) {
//   //       console.log('Cache exists but filters changed');
//   //       // Set cached business names to avoid refetching
//   //       setBusinessNames(cachedData.businessNames || {});
//   //       setIsLoading(false);
//   //       setCacheLoaded(true);
//   //       setHasMatchingCache(false);
//   //     } else {
//   //       // No cache available, load with spinner
//   //       setHasMatchingCache(false);
//   //       fetchProductsData(1, true);
//   //     }
//   //   };

//   //   loadData();

//   //   // Cleanup function to clear any pending timers
//   //   return () => {
//   //     if (cacheUpdateTimerRef.current) {
//   //       clearTimeout(cacheUpdateTimerRef.current);
//   //     }
//   //   };
//   // }, []);

//   useEffect(() => {
//     const loadData = async () => {
//       // First check cache
//       const cachedData = getFromCache();
//       const cachedFilters = getCachedFilters();

//       if (cachedData && cachedFilters && doesCacheMatchFilters(cachedData, cachedFilters)) {
//         console.log('Loading products from cache with matching filters');
//         // Set the cached data
//         setProducts(cachedData.products || []);
//         setBusinessNames(cachedData.businessNames || {});
//         setTotalProducts(cachedData.totalProducts || 0);
//         setNextPageUrl(cachedData.nextPageUrl);
//         setPrevPageUrl(cachedData.prevPageUrl);
//         setCurrentPage(cachedData.currentPage || 1);
//         setHasMatchingCache(true);

//         // Show cached content immediately
//         setIsLoading(false);
//         setCacheLoaded(true);

//         // Fetch fresh data in background without showing loading spinner
//         fetchProductsData(cachedData.currentPage || 1, false);
//       } else if (cachedData) {
//         console.log('Cache exists but filters changed - waiting for Search component to apply filters');
//         // Set cached business names to avoid refetching
//         setBusinessNames(cachedData.businessNames || {});
//         setIsLoading(false);
//         setCacheLoaded(true);
//         setHasMatchingCache(false);

//         // DON'T fetch unfiltered products here - let Search component handle it
//         // The Search component will apply the cached filters and fetch the correct products
//       } else {
//         //console.log('No cache available - waiting for Search component to load initial data');
//         // No cache available, let Search component handle initial load
//         setHasMatchingCache(false);
//         setIsLoading(false); // Don't show loading spinner, Search will handle it
//         setCacheLoaded(true);
//       }
//     };

//     loadData();

//     // Cleanup function to clear any pending timers
//     return () => {
//       if (cacheUpdateTimerRef.current) {
//         clearTimeout(cacheUpdateTimerRef.current);
//       }
//     };
//   }, []);

//   // Save to cache when critical data changes, but only if we've already loaded data
//   useEffect(() => {
//     // Only save to cache if we have products and not during initial loading
//     if (products.length > 0 && !loading) {
//       // Get current filter state from Search component
//       const currentFilters = searchRef.current ? {
//         searchTerm: searchRef.current.searchTerm || '',
//         selectedFilter: searchRef.current.selectedFilter || '',
//         selectedCategory: searchRef.current.selectedCategory || ''
//       } : { searchTerm: '', selectedFilter: '', selectedCategory: '' };

//       // Create a minimal version of products to store in cache
//       const minimalProducts = products.map(product => ({
//         id: product.id,
//         name: product.name,
//         price: product.price,
//         business: product.business,
//         condition: product.condition,
//         primary_image: product.primary_image ||
//           (product.images && product.images.length > 0 ? product.images[0].image : null)
//       }));

//       const cacheData = {
//         products: minimalProducts,
//         businessNames,
//         totalProducts,
//         nextPageUrl,
//         prevPageUrl,
//         currentPage,
//         appliedFilters: currentFilters,
//         timestamp: Date.now()
//       };

//       saveToCache(cacheData);
//     }
//   }, [products, businessNames, totalProducts, nextPageUrl, prevPageUrl, currentPage]);

//   // Fetch dead-end products when no results
//   useEffect(() => {
//     if (!loading && products.length === 0 && deadEndProducts.length === 0) {
//       fetchDeadEndProducts();
//     }
//   }, [loading, products.length, deadEndProducts.length]);

//   const fetchProductsData = async (pageNumber, showLoading = true) => {
//     if (showLoading) {
//       setIsLoading(true);
//     }

//     try {
//       const response = await axios.get(`${API_URL}api/search/`, {
//         params: {
//           search: searchRef.current?.searchTerm || '',
//           filter: searchRef.current?.selectedFilter || '',
//           category: searchRef.current?.selectedCategory || '',
//           page: pageNumber,
//           page_size: productsPerPage
//         },
//         timeout: 30000
//       });

//       const newProducts = response.data.results || [];

//       setProducts(newProducts);
//       setTotalProducts(response.data.count || 0);
//       setNextPageUrl(response.data.next);
//       setPrevPageUrl(response.data.previous);
//       setCurrentPage(pageNumber);

//       // Fetch business names for the current products efficiently
//       fetchBusinessNames(newProducts);

//     } catch (error) {
//       console.error('Error fetching products data:', error);
//       // If this was a background refresh after cache load, keep showing cached data
//       if (!showLoading && cacheLoaded) {
//         console.log('Background refresh failed, keeping cached data');
//       }
//     } finally {
//       if (showLoading) {
//         setIsLoading(false);
//       }
//     }
//   };

//   const paginate = async (pageNumber) => {
//     setIsLoading(true);
//     try {
//       await fetchProductsData(pageNumber, true);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const fetchBusinessNames = async (productsList) => {
//     const businessData = { ...businessNames };
//     const missingBusinessIds = [];

//     productsList.forEach(product => {
//       if (product.business && !businessData[product.business]) {
//         missingBusinessIds.push(product.business);
//       }
//     });

//     if (missingBusinessIds.length === 0) {
//       return;
//     }

//     try {
//       // Use Promise.allSettled for better error handling
//       const promises = missingBusinessIds.map(async (businessId) => {
//         try {
//           const business = await fetchBusinessById(businessId);
//           return { id: businessId, name: business.name };
//         } catch (error) {
//           console.error(`Error fetching business ${businessId}:`, error);
//           return { id: businessId, name: 'Unknown Business' };
//         }
//       });

//       const businessResults = await Promise.allSettled(promises);
//       const updatedBusinessData = { ...businessData };

//       businessResults.forEach((result, index) => {
//         if (result.status === 'fulfilled') {
//           const { id, name } = result.value;
//           updatedBusinessData[id] = name;
//         }
//       });

//       setBusinessNames(updatedBusinessData);
//     } catch (error) {
//       console.error('Error fetching business names:', error);
//     }
//   };

//   const fetchDeadEndProducts = async () => {
//     setLoadingDeadEnds(true);
//     try {
//       const promises = productsfordeadends.map(async (productId) => {
//         try {
//           const response = await axios.get(`${API_URL}api/products/${productId}/`, {
//             timeout: 10000 // Faster timeout for dead-end products
//           });
//           return response.data;
//         } catch (error) {
//           console.error(`Error fetching product ${productId}:`, error);
//           return null;
//         }
//       });

//       const results = await Promise.allSettled(promises);
//       const validProducts = results
//         .filter(result => result.value !== null) //result.status === 'fulfilled' &&
//         .map(result => result.value);

//       setDeadEndProducts(validProducts);

//       if (validProducts.length > 0) {
//         fetchBusinessNames(validProducts);
//       }
//     } catch (error) {
//       console.error('Error fetching dead-end products:', error);
//     } finally {
//       setLoadingDeadEnds(false);
//     }
//   };

//   // Loading spinner (only show if no cache data available)
//   const LoadingSpinner = () => (
//     <div className="loading-overlay">
//       <div className="spinner-container">
//         <div className="spinner"></div>
//         <p>Loading products...</p>
//       </div>
//     </div>
//   );

//   // Pagination component
//   const Pagination = () => {
//     const totalPages = Math.ceil(totalProducts / productsPerPage);

//     const getPageNumbers = () => {
//       let pages = [];

//       if (totalPages <= 5) {
//         for (let i = 1; i <= totalPages; i++) {
//           pages.push(i);
//         }
//       } else {
//         pages.push(1);

//         let start = Math.max(2, currentPage - 1);
//         let end = Math.min(totalPages - 1, currentPage + 1);

//         if (start > 2) {
//           pages.push('...');
//         }

//         for (let i = start; i <= end; i++) {
//           pages.push(i);
//         }

//         if (end < totalPages - 1) {
//           pages.push('...');
//         }

//         if (totalPages > 1) {
//           pages.push(totalPages);
//         }
//       }

//       return pages;
//     };

//     return totalPages > 1 ? (
//       <div className="pagination">
//         <button
//           onClick={() => paginate(currentPage - 1)}
//           disabled={!prevPageUrl}
//           className="pagination-button"
//         >
//           Previous
//         </button>

//         <div className="page-numbers">
//           {getPageNumbers().map((number, index) => (
//             number === '...' ? (
//               <span key={`ellipsis-${index}`} className="ellipsis">...</span>
//             ) : (
//               <button
//                 key={number}
//                 onClick={() => paginate(number)}
//                 className={`page-number ${currentPage === number ? 'active' : ''}`}
//               >
//                 {number}
//               </button>
//             )
//           ))}
//         </div>

//         <button
//           onClick={() => paginate(currentPage + 1)}
//           disabled={!nextPageUrl}
//           className="pagination-button"
//         >
//           Next
//         </button>
//       </div>
//     ) : null;
//   };

//   const startIndex = (currentPage - 1) * productsPerPage + 1;
//   const endIndex = Math.min(startIndex + products.length - 1, totalProducts);

//   return (
//     <div className="shop-page">
//       <Helmet>
//         <title>Shop Sustainable Brands | Verdure</title>
//         <meta name="description" content="Explore handpicked sustainable, ethical, and indie brands across fashion, home, beauty, and more. Discover your next favorite small business on Verdure." />
//         <meta property="og:title" content="Shop Sustainable Brands | Verdure" />
//         <meta property="og:description" content="Explore indie brands with purpose. Every product is vetted for sustainability and transparency." />
//       </Helmet>

//       {loading && <LoadingSpinner />}

//       <div className="shipping-banner">
//         <div className="banner-content">
//           <span className="shipping-icon">🚚</span>
//           <span className="banner-text">FREE SHIPPING on orders $75+</span>
//           <span className="sparkle">✨</span>
//         </div>
//       </div>

//       <header className="shop-header">
//         <div className="header-content">
//           <div className="search-container">
//             {/* <Search
//               setProducts={setProducts}
//               setTotalProducts={setTotalProducts}
//               setIsLoading={setIsLoading}
//               currentPage={currentPage}
//               setCurrentPage={setCurrentPage}
//               ref={searchRef}
//               setNextPageUrl={setNextPageUrl}
//               setPrevPageUrl={setPrevPageUrl}
//               hasMatchingCache={hasMatchingCache}
//             /> */}

// <Search
//   setProducts={setProducts}
//   setTotalProducts={setTotalProducts}
//   setIsLoading={setIsLoading}
//   currentPage={currentPage}          // Added this prop
//   setCurrentPage={setCurrentPage}    // Added this prop
//   ref={searchRef}
//   setNextPageUrl={setNextPageUrl}
//   setPrevPageUrl={setPrevPageUrl}
//   hasMatchingCache={hasMatchingCache}
// />
//           </div>
//         </div>
//       </header>

//       <main className="shop-main">
//         {!loading && products.length === 0 && (
//           <div className="no-products-section">
//             {/* change this to just show 4 hardcoded products with no api calls */}
//             <div className="no-products-message">
//               This Week's Faves:
//             </div>

//             {deadEndProducts.length > 0 && (
//               <div className="dead-end-products">
//                 <h2 className="dead-end-title">No products found matching your criteria. Contact us and check these out instead!</h2>
//                 <div className="products-grid">
//                   {deadEndProducts.map((product) => (
//                     <div key={product.id} className="product-card">
//                       <Link to={`/shop/products/${product.id}`} className="product-link">
//                         <div className="product-image-container">
//                           {product.primary_image ? (
//                             <img
//                               src={product.primary_image}
//                               alt={product.name}
//                               className="product-image"
//                               loading="lazy"
//                             />
//                           ) : product.images && product.images.length > 0 && product.images[0].image ? (
//                             <img
//                               src={product.images[0].image}
//                               alt={product.name}
//                               className="product-image"
//                               loading="lazy"
//                             />
//                           ) : (
//                             <div className="product-image-placeholder">
//                               <span>No Image</span>
//                             </div>
//                           )}
//                         </div>
//                         <div className="product-info">
//                           <h3 className="product-name">{product.name}</h3>
//                           <p className="product-business">{businessNames[product.business] || 'Loading...'}</p>
//                           <p className="product-price">${product.price}</p>
//                           <p className="product-condition">
//                             {product.condition === "second_hand" ? "Secondhand" :
//                              product.condition === "new" ? "New" :
//                              product.condition}
//                           </p>
//                         </div>
//                       </Link>
//                     </div>
//                   ))}
//                 </div>
//                 <div className="contact-suggestion">
//                   <p>Contact us to suggest more products!</p>
//                 </div>
//               </div>
//             )}

//             {loadingDeadEnds && (
//               <div className="loading-dead-ends">
//                 <p>Loading suggestions...</p>
//               </div>
//             )}
//           </div>
//         )}

//         {products.length > 0 && (
//           <>
//             <div className="products-grid">
//               {products.map((product) => (
//                 <div key={product.id} className="product-card">
//                   <Link to={`/shop/products/${product.id}`} className="product-link">
//                     <div className="product-image-container">
//                       {product.primary_image ? (
//                         <img
//                           src={product.primary_image}
//                           alt={product.name}
//                           className="product-image"
//                           loading="lazy"
//                         />
//                       ) : product.images && product.images.length > 0 && product.images[0].image ? (
//                         <img
//                           src={product.images[0].image}
//                           alt={product.name}
//                           className="product-image"
//                           loading="lazy"
//                         />
//                       ) : (
//                         <div className="product-image-placeholder">
//                           <span>No Image</span>
//                         </div>
//                       )}
//                     </div>
//                     <div className="product-info">
//                       <h3 className="product-name">{product.name}</h3>
//                       <p className="product-business">{businessNames[product.business] || 'Loading...'}</p>
//                       <p className="product-price">${product.price}</p>
//                       <p className="product-condition">
//                         {product.condition === "second_hand" ? "Secondhand" :
//                           product.condition === "new" ? "New" :
//                             product.condition}
//                       </p>
//                     </div>
//                   </Link>
//                 </div>
//               ))}
//             </div>

//             <Pagination />

//             {totalProducts > 0 && (
//               <div className="results-summary">
//                 Showing {startIndex}-{endIndex} of {totalProducts} products
//               </div>
//             )}
//           </>
//         )}
//       </main>

//             {/* CSS styles kept the same as original */}
//             <style jsx>{`
//         * {
//           box-sizing: border-box;
//           margin: 0;
//           padding: 0;
//         }

//         html, body {
//           width: 100%;
//           overflow-x: hidden;
//           margin: 0;
//           padding: 0;
//         }

//         .shop-page {
//           font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
//           min-height: 100vh;
//           background-color: #fff;
//           position: relative;
//           width: 100%;
//           max-width: 100%;
//           overflow-x: hidden;
//         }

//         .shop-header {
//           background-color: #c9d8c093;
//           color: #3e4a1b;
//           padding: 1.5rem 0;
//           box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
//           width: 100%;
//         }

//         .header-content {
//           max-width: 1200px;
//           margin: 0 auto;
//           padding: 0 1rem;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           width: 100%;
//         }

//         .logo {
//           font-size: 2.5rem;
//           font-weight: 600;
//           margin: 0 0 1.5rem;
//           letter-spacing: 1px;
//           color: #3e4a1b;
//           text-align: center;
//         }

//         .search-container {
//           width: 100%;
//           max-width: 800px;
//           color: transparent;
//           display: flex;
//           justify-content: center;
//         }

//         /* Make sure Search component is centered */
//         .search-container > * {
//           width: 100%;
//         }

//         .shop-main {
//           max-width: 1200px;
//           margin: 2rem auto;
//           padding: 0 1rem;
//           width: 100%;
//         }

//         .products-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
//           gap: 2rem;
//           width: 100%;
//           margin-bottom: 2rem;
//         }

//         .product-card {
//           background-color: white;
//           border-radius: 12px;
//           overflow: hidden;
//           box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
//           transition: transform 0.2s, box-shadow 0.2s;
//           height: 100%;
//           display: flex;
//           flex-direction: column;
//           width: 100%;
//         }

//         .product-card:hover {
//           transform: translateY(-5px);
//           box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
//         }

//         .product-link {
//           text-decoration: none;
//           color: inherit;
//           display: flex;
//           flex-direction: column;
//           height: 100%;
//           width: 100%;
//         }

//         .product-image-container {
//           height: 240px;
//           overflow: hidden;
//           background-color: #f9f9f9;
//           position: relative;
//         }

//         .product-image {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           transition: transform 0.3s;
//         }

//         .product-card:hover .product-image {
//           transform: scale(1.05);
//         }

//         .product-image-placeholder {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           height: 100%;
//           background-color: #f0f0f0;
//           color: #999;
//         }

//         .product-info {
//           padding: 1.25rem;
//           flex-grow: 1;
//           display: flex;
//           flex-direction: column;
//         }

//         .product-name {
//           font-size: 1.1rem;
//           font-weight: 600;
//           margin: 0 0 0.5rem;
//           color: #3e4a1b;
//           overflow: hidden;
//           text-overflow: ellipsis;
//           display: -webkit-box;
//           -webkit-line-clamp: 2;
//           -webkit-box-orient: vertical;
//         }

//         .product-business {
//           font-size: 0.9rem;
//           color: #666;
//           margin: 0 0 0.75rem;
//           overflow: hidden;
//           text-overflow: ellipsis;
//           white-space: nowrap;
//         }

//         .product-price {
//           font-size: 1.25rem;
//           font-weight: 600;
//           color: #3e4a1b;
//           margin: 0 0 0.5rem;
//         }

//         .product-condition {
//           font-size: 0.85rem;
//           color: #666;
//           margin: 0;
//           text-transform: capitalize;
//         }

//         .no-products-message {
//           text-align: center;
//           padding: 3rem 0;
//           font-size: 1.125rem;
//           color: #666;
//         }

//         .loading-overlay {
//           position: fixed;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background: rgba(255, 255, 255, 0.8);
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           z-index: 1000;
//         }

//         .spinner-container {
//           text-align: center;
//         }

//         .spinner {
//           display: inline-block;
//           width: 50px;
//           height: 50px;
//           border: 4px solid rgba(201, 216, 192, 0.3);
//           border-radius: 50%;
//           border-top-color: #3e4a1b;
//           animation: spin 1s ease-in-out infinite;
//           margin-bottom: 1rem;
//         }

//         .spinner-container p {
//           color: #3e4a1b;
//           font-weight: 500;
//         }

//         /* Pagination Styles */
//         .pagination {
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           margin: 2rem 0;
//           gap: 0.5rem;
//         }

//         .page-numbers {
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//         }

//         .pagination-button, .page-number {
//           background-color: white;
//           border: 1px solid #ddd;
//           padding: 0.6rem 1rem;
//           border-radius: 6px;
//           font-size: 0.9rem;
//           cursor: pointer;
//           transition: all 0.2s;
//           color: #3e4a1b;
//         }

//         .pagination-button:hover, .page-number:hover {
//           background-color: #f0f0f0;
//         }

//         .pagination-button:disabled {
//           background-color: #f9f9f9;
//           color: #ccc;
//           cursor: not-allowed;
//           border-color: #eee;
//         }

//         .page-number.active {
//           background-color: #3e4a1b;
//           color: white;
//           border-color: #3e4a1b;
//           font-weight: 600;
//         }

//         .ellipsis {
//           padding: 0.6rem 0.5rem;
//           color: #666;
//         }

//         .results-summary {
//           text-align: center;
//           color: #666;
//           font-size: 0.9rem;
//           margin-top: 1rem;
//         }

//         @keyframes spin {
//           to { transform: rotate(360deg); }
//         }

//         /* Enhanced Mobile Styles */
//         @media (max-width: 768px) {
//           .logo {
//             font-size: 2rem;
//             margin-bottom: 1rem;
//           }

//           .products-grid {
//             grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
//             gap: 1rem;
//           }

//           .product-image-container {
//             height: 160px;
//           }

//           .product-info {
//             padding: 0.75rem;
//           }

//           .product-name {
//             font-size: 0.9rem;
//             margin-bottom: 0.3rem;
//           }

//           .product-business {
//             font-size: 0.8rem;
//             margin-bottom: 0.5rem;
//           }

//           .product-price {
//             font-size: 1rem;
//             margin-bottom: 0.3rem;
//           }

//           .product-condition {
//             font-size: 0.75rem;
//           }

//           /* Mobile Pagination */
//           .pagination {
//             flex-wrap: wrap;
//           }

//           .page-numbers {
//             order: 2;
//             width: 100%;
//             justify-content: center;
//             margin-top: 0.5rem;
//           }

//           .pagination-button {
//             flex: 1;
//             max-width: 100px;
//           }
//         }

//         /* Small mobile devices */
//         @media (max-width: 480px) {
//           .products-grid {
//             grid-template-columns: repeat(2, 1fr);
//             gap: 0.8rem;
//           }

//           .product-image-container {
//             height: 140px;
//           }

//           .product-card {
//             border-radius: 8px;
//           }

//           .shop-header {
//             padding: 1rem 0;
//           }

//           .logo {
//             font-size: 1.8rem;
//             margin-bottom: 0.8rem;
//           }

//           .shop-main {
//             margin: 1rem auto;
//           }

//           /* Ensure full width for search elements */
//           .search-container {
//             max-width: 100%;
//           }

//           /* Smaller pagination for tiny screens */
//           .page-number, .pagination-button {
//             padding: 0.5rem;
//             font-size: 0.85rem;
//           }
//         }

//         /* Very small devices */
//         @media (max-width: 350px) {
//           .products-grid {
//             grid-template-columns: 1fr;
//             gap: 1rem;
//           }

//           .product-image-container {
//             height: 180px;
//           }

//           .logo {
//             font-size: 1.6rem;
//           }

//           /* Hide some page numbers on tiny screens */
//           .page-numbers .page-number:not(.active):not(:first-child):not(:last-child) {
//             display: none;
//           }
//         }

// .shipping-banner {
//   width: 100%;
//   background: linear-gradient(135deg, #4ade80 0%, #22c55e 50%, #16a34a 100%);
//   background-size: 400% 400%;
//   animation: bannerGradient 8s ease infinite;
//   padding: 0.75rem 0;
//   position: relative;
//   overflow: hidden;
//   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
// }

// .shipping-banner::before {
//   content: '';
//   position: absolute;
//   top: 0;
//   left: -100%;
//   width: 100%;
//   height: 100%;
//   background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
//   animation: bannerShine 3s infinite;
// }

// .banner-content {
//   max-width: 1200px;
//   margin: 0 auto;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   gap: 0.5rem;
//   padding: 0 1rem;
//   color: white;
//   font-weight: 600;
//   font-size: 0.95rem;
//   letter-spacing: 0.5px;
//   text-transform: uppercase;
// }

// .shipping-icon {
//   font-size: 1.2rem;
//   animation: bounce 2s infinite;
// }

// .banner-text {
//   text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
// }

// .sparkle {
//   font-size: 1rem;
//   animation: sparkle 2s ease-in-out infinite alternate;
// }

// @keyframes bannerGradient {
//   0% { background-position: 0% 50%; }
//   50% { background-position: 100% 50%; }
//   100% { background-position: 0% 50%; }
// }

// @keyframes bannerShine {
//   0% { left: -100%; }
//   100% { left: 100%; }
// }

// @keyframes bounce {
//   0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
//   40% { transform: translateY(-3px); }
//   60% { transform: translateY(-2px); }
// }

// @keyframes sparkle {
//   0% { opacity: 0.5; transform: scale(1); }
//   100% { opacity: 1; transform: scale(1.2); }
// }

// /* Mobile responsiveness for banner */
// @media (max-width: 768px) {
//   .banner-content {
//     font-size: 0.85rem;
//     gap: 0.4rem;
//   }

//   .shipping-icon {
//     font-size: 1rem;
//   }

//   .sparkle {
//     font-size: 0.9rem;
//   }
// }

// @media (max-width: 480px) {
//   .shipping-banner {
//     padding: 0.6rem 0;
//   }

//   .banner-content {
//     font-size: 0.8rem;
//     gap: 0.3rem;
//   }

//   .banner-text {
//     text-align: center;
//   }
// }

// .no-products-section {
//   text-align: center;
//   padding: 2rem;
// }

// .dead-end-products {
//   margin-top: 2rem;
// }

// .dead-end-title {
//   font-size: 1.5rem;
//   margin-bottom: 1.5rem;
//   color: #333;
// }

// .contact-suggestion {
//   margin-top: 2rem;
//   padding: 1rem;
//   background-color: #f8f9fa;
//   border-radius: 8px;
//   font-style: italic;
// }

// .loading-dead-ends {
//   margin-top: 1rem;
//   color: #666;
// }

//       `}</style>
//     </div>
//   );
// };

// export default Shop;

import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Search from "./Search";
import { fetchBusinessById, API_URL } from "../services/api";
import axios from "axios";
import { Helmet } from "react-helmet";

import bracelet from "./bracelet.jpg";
import yyshoes from "./yyshoes.jpg";
import cami from "./cami.jpg";
import seaturtlesocks from "./seaturtlesocks.jpg";
import watercolor from "./watercolor.jpg";
import purpleplumskincare from "./purpleplumskincare.jpg";
import goldbracelet from "./goldbracelet.jpg";
import blush from "./blush.jpg";

// Cache constants
const CACHE_KEY = "shop_products_cache";
const CACHE_EXPIRY = 20 * 60 * 1000; // 20 minutes in milliseconds
const FILTER_CACHE_KEY = "shop_filters_cache";

// weeky favorites harcodewd
const WEEKLY_FAVORITES = [
  {
    id: "2630",
    name: "Save the Rainforest OMA Bracelet",
    price: "25.00",
    business: "Earth Tribe Shop",
    condition: "new",
    image: bracelet,
    link: "/shop/products/2630",
    businessLink: "/businessproducts/20",
  },
  {
    id: "1735",
    name: "Pure Cleansing Natural Face Milk - Rose Bliss",
    price: "24.99",
    business: "PurplePlumeria",
    condition: "new",
    image: purpleplumskincare,
    link: "/shop/products/1735",
    businessLink: "/businessproducts/34",
  },
  {
    id: "2788",
    name: "Sugar Cane Watercolor Paper",
    price: "32.95",
    business: "Natural Earth Paint",
    condition: "new",
    image: watercolor,
    link: "/shop/products/2788",
    businessLink: "/businessproducts/38",
  },
  {
    id: "1948",
    name: "Stratus Cactus White / Grey / Black / White",
    price: "138.00",
    business: "YY Nation",
    condition: "new",
    image: yyshoes,
    link: "/shop/products/1948",
    businessLink: "/businessproducts/32",
  },
  {
    id: "2633",
    name: "Sea Turtle Socks",
    price: "15.00",
    business: "Earth Tribe Shop",
    condition: "new",
    image: seaturtlesocks,
    link: "/shop/products/2633",
    businessLink: "/businessproducts/20",
  },

  {
    id: "fav6",
    name: "Organic Blue Floral Cami",
    price: "38.00",
    business: "Earth Tribe Shop",
    condition: "new",
    image: cami,
    link: "/shop/products/2556",
    businessLink: "/businessproducts/20",
  },

  {
    id: "fav7",
    name: "Creamy Vegan Blush Stick - Bloom",
    price: "22.99",
    business: "River Organics",
    condition: "new",
    image: blush,
    link: "/shop/products/428",
    businessLink: "/businessproducts/23",
  },

  {
    id: "fav8",
    name: "Beaded Gold Filled Chain Bracelet",
    price: "44.00",
    business: "Earth Tribe Shop",
    condition: "new",
    image: goldbracelet,
    link: "/shop/products/2412",
    businessLink: "/businessproducts/20",
  },
];

const Shop = () => {
  const [products, setProducts] = useState([]);
  const [businessNames, setBusinessNames] = useState({});
  // CHANGING THE FOLLOWING LINE TO FALSE
  // const [loading, setIsLoading] = useState(true);
  const [loading, setIsLoading] = useState(false);
  const [cacheLoaded, setCacheLoaded] = useState(false);
  const [hasMatchingCache, setHasMatchingCache] = useState(false);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [totalProducts, setTotalProducts] = useState(0);
  const [nextPageUrl, setNextPageUrl] = useState(null);
  const [prevPageUrl, setPrevPageUrl] = useState(null);
  const productsPerPage = 20;
  const productsfordeadends = [414, 1718, 1751, 1733, 1721, 1748, 483, 397]; // CHANGE THIS FOR THE ACTUAL PRODUCTS
  const [deadEndProducts, setDeadEndProducts] = useState([]);
  const [loadingDeadEnds, setLoadingDeadEnds] = useState(false);

  // Search API ref for the child component to use
  const searchRef = React.useRef();

  // Ref to prevent duplicate cache saves
  const cacheUpdateTimerRef = useRef(null);
  const cacheSavedDataRef = useRef(null);

  const [showWeeklyFavorites, setShowWeeklyFavorites] = useState(true);

  // Optimized cache helpers
  const saveToCache = (cacheData) => {
    const stringifiedData = JSON.stringify(cacheData);

    if (cacheSavedDataRef.current === stringifiedData) {
      return;
    }

    cacheSavedDataRef.current = stringifiedData;

    if (cacheUpdateTimerRef.current) {
      clearTimeout(cacheUpdateTimerRef.current);
    }

    cacheUpdateTimerRef.current = setTimeout(() => {
      try {
        localStorage.setItem(CACHE_KEY, stringifiedData);
      } catch (error) {
        console.error("Error saving to cache:", error);
      }
      cacheUpdateTimerRef.current = null;
    }, 300); // Reduced debounce for faster caching
  };

  const getFromCache = () => {
    try {
      const cachedItem = localStorage.getItem(CACHE_KEY);
      if (!cachedItem) return null;

      const parsedCache = JSON.parse(cachedItem);
      const { data, timestamp } = parsedCache;

      if (Date.now() - timestamp > CACHE_EXPIRY) {
        localStorage.removeItem(CACHE_KEY);
        return null;
      }

      cacheSavedDataRef.current = cachedItem;
      return data;
    } catch (error) {
      console.error("Error reading from cache:", error);
      localStorage.removeItem(CACHE_KEY);
      return null;
    }
  };

  const getCachedFilters = () => {
    try {
      const cachedFilters = localStorage.getItem(FILTER_CACHE_KEY);
      if (cachedFilters) {
        return JSON.parse(cachedFilters);
      }
    } catch (error) {
      console.error("Error reading cached filters:", error);
    }
    return null;
  };

  // Check if cached data matches current filters
  const doesCacheMatchFilters = (cachedData, filters) => {
    if (!cachedData || !cachedData.appliedFilters) return false;

    const { searchTerm, selectedFilter, selectedCategory } = filters;
    const cached = cachedData.appliedFilters;

    return (
      cached.searchTerm === searchTerm &&
      cached.selectedFilter === selectedFilter &&
      cached.selectedCategory === selectedCategory
    );
  };

  // Load data once on component mount

  // v3

  useEffect(() => {
    const loadData = async () => {
      const cachedData = getFromCache();
      const cachedFilters = getCachedFilters();

      if (
        cachedData &&
        cachedFilters &&
        doesCacheMatchFilters(cachedData, cachedFilters)
      ) {
        console.log("Loading products from cache with matching filters");
        setProducts(cachedData.products || []);
        setBusinessNames(cachedData.businessNames || {});
        setTotalProducts(cachedData.totalProducts || 0);
        setNextPageUrl(cachedData.nextPageUrl);
        setPrevPageUrl(cachedData.prevPageUrl);
        setCurrentPage(cachedData.currentPage || 1);
        setHasMatchingCache(true);
        setShowWeeklyFavorites(false); // Hide weekly favorites when we have real products
        setIsLoading(false);
        setCacheLoaded(true);
      } else if (cachedData) {
        console.log(
          "Cache exists but filters changed - waiting for Search component to apply filters"
        );
        setBusinessNames(cachedData.businessNames || {});
        setShowWeeklyFavorites(true); // Show weekly favorites initially
        setIsLoading(false);
        setCacheLoaded(true);
        setHasMatchingCache(false);
      } else {
        console.log("No cache available - showing weekly favorites");
        setShowWeeklyFavorites(true); // Show weekly favorites initially
        setHasMatchingCache(false);
        setIsLoading(false);
        setCacheLoaded(true);
      }
    };

    loadData();

    return () => {
      if (cacheUpdateTimerRef.current) {
        clearTimeout(cacheUpdateTimerRef.current);
      }
    };
  }, []);

  // Save to cache when critical data changes, but only if we've already loaded data
  useEffect(() => {
    // Only save to cache if we have products and not during initial loading
    if (products.length > 0 && !loading) {
      // Get current filter state from Search component
      const currentFilters = searchRef.current
        ? {
            searchTerm: searchRef.current.searchTerm || "",
            selectedFilter: searchRef.current.selectedFilter || "",
            selectedCategory: searchRef.current.selectedCategory || "",
          }
        : { searchTerm: "", selectedFilter: "", selectedCategory: "" };

      // Create a minimal version of products to store in cache
      const minimalProducts = products.map((product) => ({
        id: product.id,
        name: product.name,
        price: product.price,
        business: product.business,
        condition: product.condition,
        primary_image:
          product.primary_image ||
          (product.images && product.images.length > 0
            ? product.images[0].image
            : null),
      }));

      const cacheData = {
        products: minimalProducts,
        businessNames,
        totalProducts,
        nextPageUrl,
        prevPageUrl,
        currentPage,
        appliedFilters: currentFilters,
        timestamp: Date.now(),
      };

      saveToCache(cacheData);
    }
  }, [
    products,
    businessNames,
    totalProducts,
    nextPageUrl,
    prevPageUrl,
    currentPage,
  ]);

  // Fetch dead-end products when no results
  // og
  // useEffect(() => {
  //   if (!loading && products.length === 0 && deadEndProducts.length === 0) {
  //     fetchDeadEndProducts();
  //   }
  // }, [loading, products.length, deadEndProducts.length]);

  useEffect(() => {
    if (
      !loading &&
      products.length === 0 &&
      deadEndProducts.length === 0 &&
      !showWeeklyFavorites
    ) {
      fetchDeadEndProducts();
    }
  }, [loading, products.length, deadEndProducts.length, showWeeklyFavorites]);

  useEffect(() => {
    if (products.length > 0 && !loading) {
      fetchBusinessNames(products);
    }
  }, [products]);

  useEffect(() => {
    if (searchRef.current?.selectedCategory === "weekly_favorites") {
      setShowWeeklyFavorites(true);
      setProducts([]);
      setTotalProducts(0);
    } else {
      setShowWeeklyFavorites(false);
    }
  }, [searchRef.current?.selectedCategory]);

  // Add this useEffect to handle when user selects Weekly Favorites
  useEffect(() => {
    if (searchRef.current?.selectedCategory === "weekly_favorites") {
      setShowWeeklyFavorites(true);
      setProducts([]);
      setTotalProducts(0);
      setIsLoading(false); // Make sure loading is false
    } else if (searchRef.current?.selectedCategory !== undefined) {
      setShowWeeklyFavorites(false);
    }
  }, [searchRef.current?.selectedCategory]);

  const fetchProductsData = async (pageNumber, showLoading = true) => {
    const hasActiveSearch =
      searchRef.current?.searchTerm ||
      searchRef.current?.selectedFilter ||
      (searchRef.current?.selectedCategory &&
        searchRef.current?.selectedCategory !== "weekly_favorites");

    // if (showLoading && searchRef.current?.selectedCategory != 'weekly_favorites' && searchRef.current?.selectedCategory != undefined) { // ading thisearchRef.current?.selectedCategory != 'weekly_favorites'
    //   console.log("loading")
    //   setIsLoading(true);
    // }

    if (showLoading && hasActiveSearch) {
      setIsLoading(true);
    }

    try {
      const response = await axios.get(`${API_URL}api/search/`, {
        params: {
          search: searchRef.current?.searchTerm || "",
          filter: searchRef.current?.selectedFilter || "",
          category: searchRef.current?.selectedCategory || "",
          page: pageNumber,
          page_size: productsPerPage,
        },
        timeout: 30000,
      });

      const newProducts = response.data.results || [];

      setProducts(newProducts);
      setTotalProducts(response.data.count || 0);
      setNextPageUrl(response.data.next);
      setPrevPageUrl(response.data.previous);
      setCurrentPage(pageNumber);

      // Fetch business names for the current products efficiently
      //fetchBusinessNames(newProducts);
    } catch (error) {
      console.error("Error fetching products data:", error);
      // If this was a background refresh after cache load, keep showing cached data
      if (!showLoading && cacheLoaded) {
        console.log("Background refresh failed, keeping cached data");
      }
    } finally {
      if (showLoading) {
        setIsLoading(false);
      }
    }
  };

  const paginate = async (pageNumber) => {
    setIsLoading(true);
    try {
      await fetchProductsData(pageNumber, true);
    } finally {
      setIsLoading(false);
    }
  };

  // const fetchBusinessNames = async (productsList) => {
  //   const businessData = { ...businessNames };
  //   const missingBusinessIds = [];

  //   productsList.forEach(product => {
  //     if (product.business && !businessData[product.business]) {
  //       missingBusinessIds.push(product.business);
  //     }
  //   });

  //   if (missingBusinessIds.length === 0) {
  //     return;
  //   }

  //   try {
  //     // Use Promise.allSettled for better error handling
  //     const promises = missingBusinessIds.map(async (businessId) => {
  //       try {
  //         const business = await fetchBusinessById(businessId);
  //         return { id: businessId, name: business.name };
  //       } catch (error) {
  //         console.error(`Error fetching business ${businessId}:`, error);
  //         return { id: businessId, name: 'Unknown Business' };
  //       }
  //     });

  //     const businessResults = await Promise.allSettled(promises);
  //     const updatedBusinessData = { ...businessData };

  //     businessResults.forEach((result, index) => {
  //       if (result.status === 'fulfilled') {
  //         const { id, name } = result.value;
  //         updatedBusinessData[id] = name;
  //       }
  //     });

  //     setBusinessNames(updatedBusinessData);
  //   } catch (error) {
  //     console.error('Error fetching business names:', error);
  //   }
  // };

  const fetchBusinessNames = async (productsList) => {
    const businessData = { ...businessNames };
    const missingBusinessIds = [];

    productsList.forEach((product) => {
      if (product.business && !businessData[product.business]) {
        missingBusinessIds.push(product.business);
      }
    });

    if (missingBusinessIds.length === 0) {
      return;
    }

    try {
      // Fetch all at once instead of one by one
      const promises = missingBusinessIds.map((businessId) =>
        fetchBusinessById(businessId).catch((error) => {
          console.error(`Error fetching business ${businessId}:`, error);
          return { id: businessId, name: "Unknown Business" };
        })
      );

      const businessResults = await Promise.all(promises);
      const updatedBusinessData = { ...businessData };

      businessResults.forEach((business) => {
        if (business && business.id) {
          updatedBusinessData[business.id] = business.name;
        }
      });

      setBusinessNames(updatedBusinessData);
    } catch (error) {
      console.error("Error fetching business names:", error);
    }
  };

  // const fetchDeadEndProducts = async () => {
  //   setLoadingDeadEnds(true);
  //   try {
  //     const promises = productsfordeadends.map(async (productId) => {
  //       try {
  //         const response = await axios.get(`${API_URL}api/products/${productId}/`, {
  //           timeout: 10000 // Faster timeout for dead-end products
  //         });
  //         return response.data;
  //       } catch (error) {
  //         console.error(`Error fetching product ${productId}:`, error);
  //         return null;
  //       }
  //     });

  //     const results = await Promise.allSettled(promises);
  //     const validProducts = results
  //       .filter(result => result.value !== null) //result.status === 'fulfilled' &&
  //       .map(result => result.value);

  //     setDeadEndProducts(validProducts);

  //     if (validProducts.length > 0) {
  //       fetchBusinessNames(validProducts);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching dead-end products:', error);
  //   } finally {
  //     setLoadingDeadEnds(false);
  //   }
  // };

  const fetchDeadEndProducts = async () => {
    setLoadingDeadEnds(true);
    try {
      const promises = productsfordeadends.map(async (productId) => {
        try {
          const response = await axios.get(
            `${API_URL}api/products/${productId}/`,
            {
              timeout: 10000,
            }
          );
          return response.data;
        } catch (error) {
          console.error(`Error fetching product ${productId}:`, error);
          return null;
        }
      });

      const results = await Promise.allSettled(promises);
      const validProducts = results
        .filter((result) => result.value !== null) //result.status === 'fulfilled' &&
        .map((result) => result.value);

      setDeadEndProducts(validProducts);

      if (validProducts.length > 0) {
        fetchBusinessNames(validProducts);
      }
    } catch (error) {
      console.error("Error fetching dead-end products:", error);
    } finally {
      setLoadingDeadEnds(false);
    }
  };

  // Loading spinner (only show if no cache data available)
  const LoadingSpinner = () => (
    <div className="loading-overlay">
      <div className="spinner-container">
        <div className="spinner"></div>
        <p>Loading products...</p>
      </div>
    </div>
  );

  // Pagination component
  const Pagination = () => {
    const totalPages = Math.ceil(totalProducts / productsPerPage);

    const getPageNumbers = () => {
      let pages = [];

      if (totalPages <= 5) {
        for (let i = 1; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);

        let start = Math.max(2, currentPage - 1);
        let end = Math.min(totalPages - 1, currentPage + 1);

        if (start > 2) {
          pages.push("...");
        }

        for (let i = start; i <= end; i++) {
          pages.push(i);
        }

        if (end < totalPages - 1) {
          pages.push("...");
        }

        if (totalPages > 1) {
          pages.push(totalPages);
        }
      }

      return pages;
    };

    return totalPages > 1 ? (
      <div className="pagination">
        <button
          onClick={() => paginate(currentPage - 1)}
          disabled={!prevPageUrl}
          className="pagination-button"
        >
          Previous
        </button>

        <div className="page-numbers">
          {getPageNumbers().map((number, index) =>
            number === "..." ? (
              <span key={`ellipsis-${index}`} className="ellipsis">
                ...
              </span>
            ) : (
              <button
                key={number}
                onClick={() => paginate(number)}
                className={`page-number ${
                  currentPage === number ? "active" : ""
                }`}
              >
                {number}
              </button>
            )
          )}
        </div>

        <button
          onClick={() => paginate(currentPage + 1)}
          disabled={!nextPageUrl}
          className="pagination-button"
        >
          Next
        </button>
      </div>
    ) : null;
  };

  const startIndex = (currentPage - 1) * productsPerPage + 1;
  const endIndex = Math.min(startIndex + products.length - 1, totalProducts);

  return (
    <div className="shop-page">
      <Helmet>
        <title>Shop Sustainable Brands | Verdure</title>
        <meta
          name="description"
          content="Explore handpicked sustainable, ethical, and indie brands across fashion, home, beauty, and more. Discover your next favorite small business on Verdure."
        />
        <meta property="og:title" content="Shop Sustainable Brands | Verdure" />
        <meta
          property="og:description"
          content="Explore indie brands with purpose. Every product is vetted for sustainability and transparency."
        />
      </Helmet>

      {loading && <LoadingSpinner />}

      <div className="shipping-banner">
        <div className="banner-content">
          <span className="shipping-icon">🚚</span>
          <span className="banner-text">FREE SHIPPING on orders $75+</span>
          <span className="sparkle">✨</span>
        </div>
      </div>

      <header className="shop-header">
        <div className="header-content">
          <div className="search-container">
            {/* <Search
              setProducts={setProducts}
              setTotalProducts={setTotalProducts}
              setIsLoading={setIsLoading}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              ref={searchRef}
              setNextPageUrl={setNextPageUrl}
              setPrevPageUrl={setPrevPageUrl}
              hasMatchingCache={hasMatchingCache}
            /> */}

            <Search
              setProducts={setProducts}
              setTotalProducts={setTotalProducts}
              setIsLoading={setIsLoading}
              currentPage={currentPage} // Added this prop
              setCurrentPage={setCurrentPage} // Added this prop
              ref={searchRef}
              setNextPageUrl={setNextPageUrl}
              setPrevPageUrl={setPrevPageUrl}
              hasMatchingCache={hasMatchingCache}
            />
          </div>
        </div>
      </header>

      <main className="shop-main">
        {!loading && products.length === 0 && (
          <div className="no-products-section">
            {/* change this to just show 4 hardcoded products with no api calls */}
            {/* <div className="no-products-message">
              This Week's Faves:
            </div> */}

            {/* {!loading && products.length === 0 && showWeeklyFavorites && ( */}
            {!loading &&
              products.length === 0 &&
              showWeeklyFavorites &&
              (!searchRef.current?.searchTerm ||
                searchRef.current?.searchTerm === "") &&
              (!searchRef.current?.selectedFilter ||
                searchRef.current?.selectedFilter === "") &&
              (!searchRef.current?.selectedCategory ||
                searchRef.current?.selectedCategory === "weekly_favorites") && (
                <div className="no-products-section">
                  <div className="weekly-favorites-container">
                    <div className="no-products-message">
                      <h2 id="currentFavH2">Current Favorites ✨</h2>
                    </div>
                    <div className="products-grid">
                      {/* {WEEKLY_FAVORITES.map((product) => ( 
                    <Link>
                    <div key={product.id} className="product-card">
                      <div className="product-link">
                        <div className="product-image-container">
                          <img
                            src={product.image}
                            alt={product.name}
                            className="product-image"
                            loading="lazy"
                          />
                        </div>
                        <div className="product-info">
                          <h3 className="product-name">{product.name}</h3>
                          <p className="product-business">{product.business}</p>
                          <p className="product-price">${product.price}</p>
                          <p className="product-condition">
                            {product.condition === "second_hand" ? "Secondhand" : 
                            product.condition === "new" ? "New" : 
                            product.condition}
                          </p>
                        </div>
                      </div>
                    </div>
                    </Link>
                  ))} */}

                      {WEEKLY_FAVORITES.map((product) => (
                        <Link to={product.link} key={product.id}>
                          <div className="product-card">
                            <div className="product-link">
                              <div className="product-image-container">
                                <img
                                  src={product.image}
                                  alt={product.name}
                                  className="product-image"
                                  loading="lazy"
                                />
                              </div>
                              <div className="product-info">
                                <h3 className="product-name">{product.name}</h3>
                                {/* <p className="product-business">{product.business}</p> */}
                                <p className="product-business">
                                  <Link to={product.businessLink}>
                                    {product.business}
                                  </Link>
                                </p>
                                <p className="product-price">
                                  ${product.price}
                                </p>
                                {/* <p className="product-condition">
                              {product.condition === "second_hand"
                                ? "Secondhand"
                                : product.condition === "new"
                                ? "New"
                                : product.condition}
                            </p> */}
                              </div>
                            </div>
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              )}

            {deadEndProducts.length > 0 && (
              <div className="dead-end-products">
                <h2 className="dead-end-title">People also love...</h2>
                <div className="products-grid">
                  {deadEndProducts.map((product) => (
                    <div key={product.id} className="product-card">
                      <Link
                        to={`/shop/products/${product.id}`}
                        className="product-link"
                      >
                        <div className="product-image-container">
                          {product.primary_image ? (
                            <img
                              src={product.primary_image}
                              alt={product.name}
                              className="product-image"
                              loading="lazy"
                            />
                          ) : product.images &&
                            product.images.length > 0 &&
                            product.images[0].image ? (
                            <img
                              src={product.images[0].image}
                              alt={product.name}
                              className="product-image"
                              loading="lazy"
                            />
                          ) : (
                            <div className="product-image-placeholder">
                              <span>No Image</span>
                            </div>
                          )}
                        </div>
                        <div className="product-info">
                          <h3 className="product-name">{product.name}</h3>
                          <p className="product-business">
                            {businessNames[product.business] || "Loading..."}
                          </p>
                          <p className="product-price">${product.price}</p>
                          {/* <p className="product-condition">
                            {product.condition === "second_hand" ? "Secondhand" : 
                             product.condition === "new" ? "New" : 
                             product.condition}
                          </p> */}
                        </div>
                      </Link>
                    </div>
                  ))}
                </div>
                <div className="contact-suggestion">
                  <p>Contact us to suggest more products!</p>
                </div>
              </div>
            )}

            {loadingDeadEnds && (
              <div className="loading-dead-ends">
                <p>Loading more suggestions...</p>
              </div>
            )}
          </div>
        )}

        {products.length > 0 && (
          <>
            <div className="products-grid">
              {products.map((product) => (
                <div key={product.id} className="product-card">
                  <Link
                    to={`/shop/products/${product.id}`}
                    className="product-link"
                  >
                    <div className="product-image-container">
                      {product.primary_image ? (
                        <img
                          src={product.primary_image}
                          alt={product.name}
                          className="product-image"
                          loading="lazy"
                        />
                      ) : product.images &&
                        product.images.length > 0 &&
                        product.images[0].image ? (
                        <img
                          src={product.images[0].image}
                          alt={product.name}
                          className="product-image"
                          loading="lazy"
                        />
                      ) : (
                        <div className="product-image-placeholder">
                          <span>No Image</span>
                        </div>
                      )}
                    </div>
                    <div className="product-info">
                      <h3 className="product-name">{product.name}</h3>
                      <p className="product-business">
                        {businessNames[product.business] || "Loading..."}
                      </p>
                      <p className="product-price">${product.price}</p>
                      <p className="product-condition">
                        {product.condition === "second_hand"
                          ? "Secondhand"
                          : product.condition === "new"
                          ? "New"
                          : product.condition}
                      </p>
                    </div>
                  </Link>
                </div>
              ))}
            </div>

            <Pagination />

            {totalProducts > 0 && (
              <div className="results-summary">
                Showing {startIndex}-{endIndex} of {totalProducts} products
              </div>
            )}
          </>
        )}
      </main>

      {/* CSS styles kept the same as original */}
      <style jsx>{`
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }

        html,
        body {
          width: 100%;
          overflow-x: hidden;
          margin: 0;
          padding: 0;
        }

        .shop-page {
          font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
          min-height: 100vh;
          background-color: #fff;
          position: relative;
          width: 100%;
          max-width: 100%;
          overflow-x: hidden;
        }

        .shop-header {
          background-color: #c9d8c093;
          color: #3e4a1b;
          padding: 1.5rem 0;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          width: 100%;
        }

        .header-content {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
        }

        .logo {
          font-size: 2.5rem;
          font-weight: 600;
          margin: 0 0 1.5rem;
          letter-spacing: 1px;
          color: #3e4a1b;
          text-align: center;
        }

        .search-container {
          width: 100%;
          max-width: 800px;
          color: transparent;
          display: flex;
          justify-content: center;
        }

        /* Make sure Search component is centered */
        .search-container > * {
          width: 100%;
        }

        .shop-main {
          max-width: 1200px;
          margin: 2rem auto;
          padding: 0 1rem;
          width: 100%;
        }

        .products-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
          gap: 2rem;
          width: 100%;
          margin-bottom: 2rem;
        }

        .product-card {
          background-color: white;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
          transition: transform 0.2s, box-shadow 0.2s;
          height: 100%;
          display: flex;
          flex-direction: column;
          width: 100%;
        }

        .product-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
        }

        .product-link {
          text-decoration: none;
          color: inherit;
          display: flex;
          flex-direction: column;
          height: 100%;
          width: 100%;
        }

        .product-image-container {
          height: 240px;
          overflow: hidden;
          background-color: #f9f9f9;
          position: relative;
        }

        .product-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s;
        }

        .product-card:hover .product-image {
          transform: scale(1.05);
        }

        .product-image-placeholder {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          background-color: #f0f0f0;
          color: #999;
        }

        .product-info {
          padding: 1.25rem;
          flex-grow: 1;
          display: flex;
          flex-direction: column;
        }

        .product-name {
          font-size: 1.1rem;
          font-weight: 600;
          margin: 0 0 0.5rem;
          color: #3e4a1b;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .product-business {
          font-size: 0.9rem;
          color: #666;
          margin: 0 0 0.75rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .product-price {
          font-size: 1.25rem;
          font-weight: 600;
          color: #3e4a1b;
          margin: 0 0 0.5rem;
        }

        .product-condition {
          font-size: 0.85rem;
          color: #666;
          margin: 0;
          text-transform: capitalize;
        }

        .no-products-message {
          text-align: center;
          padding: 3rem 0;
          font-size: 1.125rem;
          color: #666;
        }

        .loading-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(255, 255, 255, 0.8);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }

        .spinner-container {
          text-align: center;
        }

        .spinner {
          display: inline-block;
          width: 50px;
          height: 50px;
          border: 4px solid rgba(201, 216, 192, 0.3);
          border-radius: 50%;
          border-top-color: #3e4a1b;
          animation: spin 1s ease-in-out infinite;
          margin-bottom: 1rem;
        }

        .spinner-container p {
          color: #3e4a1b;
          font-weight: 500;
        }

        /* Pagination Styles */
        .pagination {
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 2rem 0;
          gap: 0.5rem;
        }

        .page-numbers {
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .pagination-button,
        .page-number {
          background-color: white;
          border: 1px solid #ddd;
          padding: 0.6rem 1rem;
          border-radius: 6px;
          font-size: 0.9rem;
          cursor: pointer;
          transition: all 0.2s;
          color: #3e4a1b;
        }

        .pagination-button:hover,
        .page-number:hover {
          background-color: #f0f0f0;
        }

        .pagination-button:disabled {
          background-color: #f9f9f9;
          color: #ccc;
          cursor: not-allowed;
          border-color: #eee;
        }

        .page-number.active {
          background-color: #3e4a1b;
          color: white;
          border-color: #3e4a1b;
          font-weight: 600;
        }

        .ellipsis {
          padding: 0.6rem 0.5rem;
          color: #666;
        }

        .results-summary {
          text-align: center;
          color: #666;
          font-size: 0.9rem;
          margin-top: 1rem;
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }

        /* Enhanced Mobile Styles */
        @media (max-width: 768px) {
          .logo {
            font-size: 2rem;
            margin-bottom: 1rem;
          }

          .products-grid {
            grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
            gap: 1rem;
          }

          .product-image-container {
            height: 160px;
          }

          .product-info {
            padding: 0.75rem;
          }

          .product-name {
            font-size: 0.9rem;
            margin-bottom: 0.3rem;
          }

          .product-business {
            font-size: 0.8rem;
            margin-bottom: 0.5rem;
          }

          .product-price {
            font-size: 1rem;
            margin-bottom: 0.3rem;
          }

          .product-condition {
            font-size: 0.75rem;
          }

          /* Mobile Pagination */
          .pagination {
            flex-wrap: wrap;
          }

          .page-numbers {
            order: 2;
            width: 100%;
            justify-content: center;
            margin-top: 0.5rem;
          }

          .pagination-button {
            flex: 1;
            max-width: 100px;
          }
        }

        /* Small mobile devices */
        @media (max-width: 480px) {
          .products-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 0.8rem;
          }

          .product-image-container {
            height: 140px;
          }

          .product-card {
            border-radius: 8px;
          }

          .shop-header {
            padding: 1rem 0;
          }

          .logo {
            font-size: 1.8rem;
            margin-bottom: 0.8rem;
          }

          .shop-main {
            margin: 1rem auto;
          }

          /* Ensure full width for search elements */
          .search-container {
            max-width: 100%;
          }

          /* Smaller pagination for tiny screens */
          .page-number,
          .pagination-button {
            padding: 0.5rem;
            font-size: 0.85rem;
          }
        }

        /* Very small devices */
        @media (max-width: 350px) {
          .products-grid {
            grid-template-columns: 1fr;
            gap: 1rem;
          }

          .product-image-container {
            height: 180px;
          }

          .logo {
            font-size: 1.6rem;
          }

          /* Hide some page numbers on tiny screens */
          .page-numbers
            .page-number:not(.active):not(:first-child):not(:last-child) {
            display: none;
          }
        }

        .shipping-banner {
          width: 100%;
          background: linear-gradient(
            135deg,
            #4ade80 0%,
            #22c55e 50%,
            #16a34a 100%
          );
          background-size: 400% 400%;
          animation: bannerGradient 8s ease infinite;
          padding: 0.75rem 0;
          position: relative;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .shipping-banner::before {
          content: "";
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.2),
            transparent
          );
          animation: bannerShine 3s infinite;
        }

        .banner-content {
          max-width: 1200px;
          margin: 0 auto;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 0.5rem;
          padding: 0 1rem;
          color: white;
          font-weight: 600;
          font-size: 0.95rem;
          letter-spacing: 0.5px;
          text-transform: uppercase;
        }

        .shipping-icon {
          font-size: 1.2rem;
          animation: bounce 2s infinite;
        }

        .banner-text {
          text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
        }

        .sparkle {
          font-size: 1rem;
          animation: sparkle 2s ease-in-out infinite alternate;
        }

        @keyframes bannerGradient {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }

        @keyframes bannerShine {
          0% {
            left: -100%;
          }
          100% {
            left: 100%;
          }
        }

        @keyframes bounce {
          0%,
          20%,
          50%,
          80%,
          100% {
            transform: translateY(0);
          }
          40% {
            transform: translateY(-3px);
          }
          60% {
            transform: translateY(-2px);
          }
        }

        @keyframes sparkle {
          0% {
            opacity: 0.5;
            transform: scale(1);
          }
          100% {
            opacity: 1;
            transform: scale(1.2);
          }
        }

        /* Mobile responsiveness for banner */
        @media (max-width: 768px) {
          .banner-content {
            font-size: 0.85rem;
            gap: 0.4rem;
          }

          .shipping-icon {
            font-size: 1rem;
          }

          .sparkle {
            font-size: 0.9rem;
          }
        }

        @media (max-width: 480px) {
          .shipping-banner {
            padding: 0.6rem 0;
          }

          .banner-content {
            font-size: 0.8rem;
            gap: 0.3rem;
          }

          .banner-text {
            text-align: center;
          }
        }

        .no-products-section {
          text-align: center;
          padding: 0;
        }

        .dead-end-products {
          margin-top: 2rem;
        }

        .dead-end-title {
          font-size: 1.5rem;
          margin-bottom: 1.5rem;
          color: #333;
        }

        .contact-suggestion {
          margin-top: 2rem;
          padding: 1rem;
          background-color: #f8f9fa;
          border-radius: 8px;
          font-style: italic;
        }

        .no-products-message h2 {
          font-size: 2.2rem;
          color: #3e4a1b;
          font-weight: 700;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          background: linear-gradient(135deg, #3e4a1b 0%, #5a6b2a 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .loading-dead-ends {
          margin-top: 1rem;
          color: #666;
        }
      `}</style>
    </div>
  );
};

export default Shop;
